import routes from '@/modules/client/client-routes';
import store from '@/modules/client/client-store';

export default {
  routes,
  store,
};
